import { Card } from "@/components/ui/card";

interface InterQuestionToolbarProps {
  children: React.ReactNode;
}

export default function InterQuestionToolbar({
  children,
}: InterQuestionToolbarProps) {
  return (
    <div className="h-0 my-0 relative">
      <div className="opacity-0 hover:opacity-100 transition-opacity z-10 text-center mx-2 absolute top-[-20px] left-0 right-0">
        <div className="bg-slate-200 h-[1px] w-full top-1/2 absolute"></div>
        <Card className="p-2 w-fit mx-auto relative flex gap-2">
          {children}
        </Card>
      </div>
    </div>
  );
}
